<script>
import store from '@state/store'
import { startOfToday, format } from 'date-fns'
import _ from 'lodash'
import { convertArrayToCSV } from 'convert-array-to-csv'
import { authComputed } from '@state/helpers'
import AdminTable from '@components/admin-table.vue'
import { INDIVIDUALS_REPORTS_TABLE_FIELDS } from '@adminCompanies/constant'
import DateRange from './dateRange.vue'

export default {
  components: {
    DateRange,
    AdminTable,
  },
  data() {
    return {
      tableFields: INDIVIDUALS_REPORTS_TABLE_FIELDS,
      currentDate: { from: '', to: startOfToday() },
      lists: [],
      loaded: false,
    }
  },
  computed: {
    ...authComputed,
    companyId() {
      return +this.$route.params.companyId
    },
  },
  mounted() {
    this.fetchData(this.currentDate)
  },
  methods: {
    convertToCSV(objArray) {
      const events =
        typeof objArray !== 'object' ? JSON.parse(objArray) : objArray

      const header = this.tableFields.map((item) => item.name)
      const rows = events.map((event) => {
        return this.tableFields.map((item) => event[item.displayField])
      })

      return convertArrayToCSV(rows, { header })
    },
    exportDataPoints() {
      const csvString = this.convertToCSV(this.lists)

      const fileName = 'individualsReports.csv'
      if (window.navigator.msSaveOrOpenBlob) {
        // IE
        const blob = new Blob([csvString])
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const a = document.createElement('a')
        a.href = 'data:attachment/csv,' + encodeURIComponent(csvString)
        a.target = '_blank'
        a.download = fileName
        document.body.appendChild(a)
        a.click()
        setTimeout(() => a.remove(), 2000)
      }
    },
    convertDate(date) {
      if (!date) {
        return ''
      }
      return format(new Date(date), 'M/d/yyyy')
    },
    setSortParams(params) {
      this.sortingList(Object.keys(params)[0], Object.values(params)[0])
    },
    sortingList(key, order = 'desc') {
      const newLists = _.sortBy(this.lists, [key])
      if (order === 'asc') {
        this.lists = newLists.reverse()
      } else {
        this.lists = newLists
      }
    },
    addDataPoints(dateRange) {
      this.currentDate = dateRange
      this.fetchData(dateRange)
    },
    fetchData(dateRange) {
      this.loaded = false
      const params = {
        companyId: this.companyId,
        from: dateRange.from,
        to: dateRange.to,
      }

      store
        .dispatch('reports/fetchIndividualsReport', params)
        .then((result) => {
          this.lists = result
        })
        .catch((err) => {
          alert(err.message || 'Something went wrong.')
        })
        .finally(() => {
          this.loaded = true
        })
    },
  },
}
</script>

<template>
  <div>
    <!-- date range -->
    <div class="flex justify-between border-b border-gray pb-10 mb-4">
      <DateRange
        @add-data-points="addDataPoints"
        @export-data-points="exportDataPoints"
      />
    </div>

    <div class="pl-8 text-gray text-lg">
      Report for {{ convertDate(currentDate.from) }} -
      {{ convertDate(currentDate.to) }}
    </div>
    <AdminTable
      table-type="USER"
      :table-fields="tableFields"
      :no-new-btn="true"
      :no-edit-btn="true"
      :no-filter-option="true"
      :no-page="true"
      :total-num="lists.length"
      :list-data="lists"
      :data-loaded="loaded"
      @table-set-sort-params="setSortParams"
    />
  </div>
</template>
